import React from 'react'
import { RegisterSubmitButton } from '@ztechapps/webui.auth'

export const UpdateRegisterButton = () => {
  return <RegisterSubmitButton text="Update registration" />
}
